import { Link } from "react-router-dom";
import { IList } from "../../../utils/generalType";
import "../sharedLandingcss/Site.css";
import "../sharedLandingcss/Site_Animate.css";
import Slide from "react-reveal/Slide";
import { jobs } from "./Services/service.utils";

const jobLists: IList[] = jobs.slice(0, 3); // Limit to 3 items for the mini version

export const JobsCardMini = () => {
  return (
    <>
      {/* Service Slide */}

      <section className="py-16 bg-gray-50 text-center">
        <h2 className="text-4xl font-semibold mb-2 space-y-2 text-gray-800 pb-8">My Success Work</h2>
        <div className=" text-white text-center py-12">
          <div className="container mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 mb-10">
            {jobLists.map((item: IList, index: number) => (
              <Slide bottom delay={index * 200} key={index}>
                <div className="p-2">
                  <div className="rounded-lg  bg-white text-black text-left shadow hover:shadow-lg">
                    <img
                      className="rounded-xl mx-auto mb-4 object-cover"
                      src={item.image}
                      alt="service"
                      style={{
                        width: "100%",
                        height: "250px",
                      }}
                    />{" "}
                    <div className="p-4">
                      <h4 className="text-xl fontJostBold mb-2">
                        {item.title}
                      </h4>
                      <p className="mb-2">{item.caption}...</p>
                      <Link
                        to={"/ourjobs/" + (Number(index) + 1) + "/" + item.title}
                        className="inline-block w-full bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-xl text-center transition"
                      >
                        About Job
                      </Link>
                    </div>
                  </div>
                </div>
              </Slide>
            ))}
          </div>


          {/* See More Button */}
          <div className="text-center">
            <Slide bottom>
              <Link
                to="/ourjobs"
                className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full transition"
              >
                See More Jobs
              </Link>
            </Slide>
          </div>

        </div>
      </section>
      {/* Service Slide */}
    </>
  );
};

export default JobsCardMini;
